export default "__VITE_ASSET__D8lxLN$y__"